import * as React from 'react'
import { ReactElement } from 'react';

export interface Props {
  title: any,
  description?: string | ReactElement,
  isBeta?: boolean,
  aboveTitle?: ReactElement
  align?: 'left' | 'center'
}

const PageHeader: React.FC<Props> = ({ title, description, aboveTitle, isBeta = false, align = "center" }: Props) => {

  return (
    <div className="text-gray-700 dark:text-gray-100 pt-24 pb-16">
      {aboveTitle}
      <h1 className={`text-4xl text-${align} text-gray-800 dark:text-gray-100`}>
        <span className="font-medium">{title}
          {isBeta &&
            <span className="align-top pl-1 text-sm font-bold">BETA</span>
          }
        </span>
      </h1>
      {description &&
        <div className=''>
          <h2 className={`text-xl text-${align}`}>{description}</h2>
        </div>
      }

    </div>
  );
}

export default PageHeader;


